import React, { useEffect, useState } from 'react';
import type { TFunction } from 'i18next';
import useUserRoles from './useUserRoles';
import getSidebarNavItems from '../utils/getSidebarNavItems';
import { ROLE } from '../constants';
import type { SidebarNavItem } from '../types/common';

/**
 * ロールによってサイドバーのコンテンツを変更する
 * @return [SidebarNavItem[]]
 */
const useNavConfig = (t: TFunction<'translation', undefined>) => {
  const { isUser, isPoweruser, isAdmin, isMaintenanceadmin, hasNoRole } = useUserRoles();
  const [navItems, setNavItems] = useState<SidebarNavItem[]>([]);

  useEffect(() => {
    if (isUser) {
      const sidebarUser = getSidebarNavItems({ role: ROLE.USER, t });
      setNavItems(sidebarUser);
    } else if (isPoweruser) {
      const sidebarPoweruser = getSidebarNavItems({ role: ROLE.POWERUSER, t });
      setNavItems(sidebarPoweruser);
    } else if (isAdmin) {
      const sidebarAdmin = getSidebarNavItems({ role: ROLE.ADMIN, t });
      setNavItems(sidebarAdmin);
    } else if (isMaintenanceadmin) {
      const sidebarMaintenanceadmin = getSidebarNavItems({ role: ROLE.MAINTENANCE_ADMIN, t });
      setNavItems(sidebarMaintenanceadmin);
    } else if (hasNoRole) {
      setNavItems([]);
    } else {
      setNavItems([]);
    }
  }, [isUser, isPoweruser, isAdmin, isMaintenanceadmin]);

  return navItems;
};

export default useNavConfig;
